export default {
  PAGE: {
    PRODUCTS_VIEW: 'PAGE_PRODUCTS_VIEW',
    PRODUCTS_MANAGE: 'PAGE_PRODUCTS_MANAGE',
    LOCATIONS_VIEW: 'PAGE_LOCATIONS_VIEW',
    LOCATIONS_MANAGE: 'PAGE_LOCATIONS_MANAGE',
    INVENTORY: 'PAGE_INVENTORY',
    CONTROL_LIST: 'PAGE_CONTROL_LIST',
    CONTROL_VIEW: 'PAGE_CONTROL_VIEW',
    MAINTENANCE_LIST: 'PAGE_MAINTENANCE_LIST',
    MAINTENANCE_VIEW: 'PAGE_MAINTENANCE_VIEW',
    SPECIAL: 'PAGE_SPECIAL',
    SETTINGS: 'PAGE_SETTINGS',
    USERS: 'PAGE_USERS'
  },
  ERROR: {
    S_400_BAD_REQUEST: 400,
    S_401_UNAUTHORIZED: 401,
    S_403_FORBIDDEN: 403,
    S_500_SERVER_EXCEPTION: 500,
    BAD_REQUEST: {
      WRONG_FORMAT: 'WRONG_FORMAT',
      RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
      UNICITY_CONSTRAINT_VIOLATION: 'UNICITY_CONSTRAINT_VIOLATION',
      RESOURCE_IN_USE: 'RESOURCE_IN_USE',
      RESOURCE_NOT_EMPTY: 'RESOURCE_NOT_EMPTY',
      CANNOT_REORDER: 'CANNOT_REORDER',
      WRONG_USER: 'WRONG_USER',
      WRONG_PASSWORD: 'WRONG_PASSWORD',
      FORBIDDEN_OPERATION: 'FORBIDDEN_OPERATION'
    },
    SERVER_EXCEPTION: {
      WRONG_OUTPUT_FORMAT: 'WRONG_OUTPUT_FORMAT',
      BROKEN_PHP: 'BROKEN_PHP',
      WRONG_DATABASE_BEHAVIOUR: 'WRONG_DATABASE_BEHAVIOUR',
      BAD_IMPLEMENTATION: 'BAD_IMPLEMENTATION'
    }
  },
  STATUS: {
    TYPE: {
      SUCCESS: 'SUCCESS',
      WARNING: 'WARNING',
      FAILURE: 'FAILURE',
      INFO: 'INFO'
    },
    ICON: {
      SUCCESS: 'checkmark',
      WARNING: 'warning sign',
      FAILURE: 'close',
      INFO: 'info circle'
    }
  },
  REORDER: {
    UP: 'UP',
    DOWN: 'DOWN'
  },
  PRODUCT: {
    TYPE: {
      NONE: 'NONE',
      PIPE: 'PIPE',
      BATTERY: 'BATTERY'
    },
    ITEM: {
      INVENTORY: {
        STATUS: {
          NONE: 'NONE',
          PRESENT: 'PRESENT',
          MISSING: 'MISSING'
        }
      },
      EVENT: {
        TYPE: {
          LIFECYCLE: 'LIFECYCLE',
          INVENTORY: 'INVENTORY',
          MAINTENANCE: 'MAINTENANCE'
        }
      },
      MAINTENANCE: {
        STATUS: {
          NONE: 'NONE',
          SUCCESS: 'SUCCESS',
          FAILURE: 'FAILURE'
        }
      }
    }
  },
  CONTACT: {
    TYPE: {
      SELF: 'SELF',
      OWNER: 'OWNER',
      SPECIFIC: 'SPECIFIC'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/AppConstants.js